export default __webpack_public_path__ + "static/media/IMG_5383.fb1bd79b.PNG";